import { render, staticRenderFns } from "./stakeholderResearch.vue?vue&type=template&id=56850275&scoped=true&"
import script from "./stakeholderResearch.vue?vue&type=script&lang=js&"
export * from "./stakeholderResearch.vue?vue&type=script&lang=js&"
import style0 from "./stakeholderResearch.vue?vue&type=style&index=0&id=56850275&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56850275",
  null
  
)

export default component.exports